<template>
  <div
    class="pane-container"
    :class="{ vertical, horizontal }"
  >
    <div class="title">
      <checkbox-input
        :value="active"
        :active-color="data.type.color"
        class="checkbox"
        @input="onCheckbox"
      />
      {{ data.type.name }}
    </div>
    <div class="content">
      <div
        v-for="value in values"
        :key="value.name"
        class="data-item"
      >
        <div class="title">
          <span class="value">{{ value.value }}</span>
        </div>
        <div class="sub-title">
          {{ value.name[0].toUpperCase() + value.name.slice(1) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },

    active: {
      type: Boolean,
      required: true,
    },

    horizontal: {
      type: Boolean,
    },

    vertical: {
      type: Boolean,
    },
  },

  computed: {
    values: function () {
      return Object.entries(this.data.stat).map((value) => ({
        name: value[0],
        value: value[1],
      }));
    },
  },

  methods: {
    onCheckbox(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
$paneGap: 30px;

.pane-container {
  user-select: none;

  display: flex;
  flex-direction: row;

  // flex: 1;

  min-width: 150px;

  border: 1px solid #dddff1; // TODO : USE constant colors!
  border-radius: 6px;
  padding: 12px;

  &.vertical {
    flex-direction: row;
    margin-bottom: $paneGap / 3;

    .content {
      width: 40%;
      margin-left: auto;
    }
  }

  &.horizontal {
    flex-direction: column;
    margin-right: $paneGap;

    .content {
    }
  }

  .content {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    .data-item {
      .title {
        font-size: 10px; // TODO: Use standart constants for fonts
        line-height: 12px;
        color: $notBlack;
      }
      .sub-title {
        color: $grey50;
        font-size: 10px; // TODO: Use standart constants for fonts
        line-height: 12px;
        margin-top: 4px;
      }
    }
  }

  &:last-child {
    margin-right: 0;
  }

  .title {
    color: $grey70;
    font-size: 14px;
    line-height: 20px;

    display: flex;
    align-items: center;

    .value {
      margin-right: 2px;
    }

    .checkbox {
      margin-right: 8px;
    }
  }
}
</style>